import { useEffect, useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements, PaymentElement, useElements, useStripe } from "@stripe/react-stripe-js";
import { Loader2 } from "lucide-react";

const stripeCache = {};
const getStripe = (pk) => {
  if (!stripeCache[pk]) stripeCache[pk] = loadStripe(pk);
  return stripeCache[pk];
};

function ConfirmForm({ amount, onSuccess, onError }) {
  const stripe = useStripe();
  const elements = useElements();
  const [busy, setBusy] = useState(false);

  const pay = async () => {
    if (!stripe || !elements) return;
    setBusy(true);
    try {
      // capture_method=manual on the server: confirming AUTHORIZES the card only.
      const { error } = await stripe.confirmPayment({
        elements,
        redirect: "if_required",
      });
      if (error) throw new Error(error.message || "Payment could not be authorized");
      onSuccess();
    } catch (e) {
      onError(e.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div>
      <PaymentElement options={{ layout: "tabs" }} />
      <button data-testid="stripe-confirm-btn" onClick={pay} disabled={!stripe || busy}
              className="btn-primary w-full mt-6">
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : null}
        {busy ? "Authorizing…" : `Authorize ${amount}`}
      </button>
      <p className="mt-3 text-xs text-zinc-500 text-center">
        Your card is authorized now and charged when your arrival code is verified — or settled under the no-show policy after the arrival window passes. Secured by Stripe.
      </p>
    </div>
  );
}

export default function StripePayment({ clientSecret, publishableKey, amountLabel, onSuccess, onError }) {
  const [ready, setReady] = useState(false);
  useEffect(() => { setReady(true); }, []);
  if (!ready) return null;
  return (
    <div data-testid="stripe-payment-element">
      <Elements stripe={getStripe(publishableKey)} options={{
        clientSecret,
        appearance: {
          theme: "night",
          variables: {
            colorPrimary: "#E50914",
            colorBackground: "#080B0D",
            colorText: "#FFFFFF",
            colorDanger: "#EF4444",
            fontFamily: "Manrope, sans-serif",
            borderRadius: "12px",
          },
        },
      }}>
        <ConfirmForm amount={amountLabel} onSuccess={onSuccess} onError={onError} />
      </Elements>
    </div>
  );
}
